import React, { useContext, useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
import { useTheme } from '@mui/material/styles';
import { ArrowBack, ArrowForward } from '@mui/icons-material';
import { useRouter } from 'next/router';
import { Grid, Stack, useMediaQuery } from '@mui/material';
import { useApolloClient } from '@apollo/client';
import getConfig from 'next/config';
import ExistingCustomerCheck from '../../../components/eir-existing-customer-check/ExistingCustomerCheck';
import { useToggle } from '../../../hooks/useToggle';
import useLocalStorage, { hasLocalStorageValue, setCode } from '../../../hooks/useLocalStorage';
import EirHeader from '../../../components/eir-header/EirHeader';
import {
  getTariffWithSimo,
  onload,
  onOfferCardSelected,
  onGetHandsets,
  onOfferCardUnSelected,
  onPortingChangeService,
  getCoTarrif,
} from '../../../components/eir-mobile-offer-container/mobile.util';
import { displayCart } from '../../../components/eir-cart/cart.util';
import RootContext from '../../../../util/root.context';
import getStrapiData from '../../../integration/strapi';
import {
  addToCartAnalytics,
  viewItemListAnalytics,
  removeFromCartAnalytics,
} from '../../../../util/gtm';
import NavBar from '../../../components/eir-nav-bar/NavBar';
import NavBarTitle from '../../../components/eir-nav-bar/NavBarTitle';
import MobileDropDownMenu from '../../../components/eir-dropdown-menu/MobileDropDownMenu';
import validateCart from '../../../components/shared/validateCart';
import { mobileEligibilityCheck } from '../../../components/shared/eligibilityCheck';
import {
  clearAllCookies,
  getCookie,
  getTokenFromCookies,
  setCookie,
} from '../../../hooks/useCookie';
// import NotificationBanner from '../../../components/eir-notification-banner/NotificationBanner';
// import BillingCheckErrorModal from '../../../components/eir-error-modal/BillingCheckErrorModal';
import { createCrossSellProspect } from '../../../integration/cross-sell.api';
import { changeOfferMobileRequest } from '../../../integration/change-offer.api';
import {
  fillDropdown,
  nextStep,
  backStep,
  handleOk,
  onLoadValuesInitializer,
  crossSellOrChangeOfferOnLoadEligibilityChecker,
} from '../../../components/eir-mobile-offer-container/mobileFunctionContainer';
import EirMetaTag from '../../../components/eir-meta-tag/EirMetaTag';
import FaqContainer from '../../../components/eir-mobile-broadband/FaqContainer';
import styles from '../../../components/eir-mobile-offer-toggle/styles';
import EirFooter from '../../../components/eir-footer/EirFooter';
import { removeTariff } from '../../../components/eir-broadband/Broadband.util';
import { SERVICE_GROUPS } from '../../../components/shared/Constants';
import EirDeviceContainer from '../../../components/eir-device-list/EirDeviceContainer';
import MobileOfferContainer from '../../../components/eir-mobile-offer-container/MobileOfferContainer';
import MfaOtpModal from '../../../components/eir-login/MfaOtpModal';
import MfaSuccessModal from '../../../components/eir-login/MfaSuccessModal';
import SimoSimTypeContainer from '../../../components/eir-simtype-selector/simoSimTypeContainer';

const KeepNumberModal = dynamic(() =>
  import('../../../components/eir-keep-number-check/KeepNumberModal')
);
// const MobileOfferContainer = dynamic(() =>
//   import('../../../components/eir-mobile-offer-container/MobileOfferContainer')
// );
// const EirDeviceContainer = dynamic(() =>
//   import('../../../components/eir-device-list/EirDeviceContainer')
// );
const ErrorModal = dynamic(() => import('../../../components/eir-error-modal/ErrorModal'));
const LoginModal = dynamic(() => import('../../../components/eir-login/LoginModal'));
const EirJourneyPickerModal = dynamic(() =>
  import('../../../components/eir-journey-picker/EirJourneyPickerModal')
);
const UANErrorModal = dynamic(() =>
  import('../../../components/eir-ascertain-service/UANErrorModal')
);
const NoEligibilityErrorModal = dynamic(() =>
  import('../../../components/eir-error-modal/NoEligibilityErrorModal')
);
const EirAbondonJourney = dynamic(() =>
  import('../../../components/eir-abondon-journey-modal/EirAbondonJourney')
);
const SubscriptionSelectionModal = dynamic(() =>
  import('../../../components/eir-change-offer/SubscriptionSelectionModal')
);
const ThirdMobileOfferSelectModal = dynamic(() =>
  import('../../../components/eir-handle-third-mobile-select/ThirdMobileOfferSelectModal')
);
const UpgradeMobileErrorModal = dynamic(() =>
  import('../../../components/eir-error-modal/UpgradMobileErrorModal')
);
const EirWebchatModal = dynamic(() =>
  import('../../../components/eir-mobile-offer-container/EirWebchatModal')
);
const AddMobileCsModal = dynamic(() =>
  import('../../../components/eir-addMobileCs/AddMobileCsModal')
);
const ApiFailureModal = dynamic(() =>
  import('../../../components/eir-error-modal/ApiFailureModal')
);
const EirRegistrationRequiredModal = dynamic(() =>
  import('../../../components/eir-login/EirRegistrationRequiredModal')
);
const SessionExpireModal = dynamic(() =>
  import('../../../components/eir-session-expire-modal/sessionExpireModal')
);
const MobileUpgradeIneligibleModal = dynamic(() =>
  import('../../../components/eir-mobile-upgrade-ineligible/MobileUpgradeIneligibleModal')
);
const LoginMain403 = dynamic(() => import('../../../components/eir-403-login/LoginMain403'));

const { publicRuntimeConfig } = getConfig();

const { MOBILE } = SERVICE_GROUPS;
export async function getServerSideProps({ req }) {
  let cmsData = {};
  let cmsDataLoginBanner = {};
  let eligibility = {};
  let journeyData = {};
  let cmsHeaderData = {};
  let cmsFooterData = {};
  let error = '';
  try {
    cmsData = await getStrapiData('mobile');
    cmsDataLoginBanner = await getStrapiData('notification-banner');
    cmsHeaderData = await getStrapiData('header');
    cmsFooterData = await getStrapiData('footer');
    journeyData = await validateCart(req.cookies);
    if (journeyData.token) {
      eligibility = await mobileEligibilityCheck({ token: journeyData.token });
      eligibility = JSON.stringify(eligibility);
    }
  } catch (err) {
    eligibility = JSON.stringify(eligibility);
    error = err.message;
  }
  return {
    props: {
      cmsData,
      eligibility,
      journeyData,
      cmsDataLoginBanner,
      cmsHeaderData,
      cmsFooterData,
      error,
    },
  };
}

// const MobileOfferPageContext = useContext;

const Mobile = ({
  cmsData,
  contentCarousel,
  journeyData,
  eligibility,
  // cmsDataLoginBanner,
  cmsHeaderData,
  cmsFooterData,
}) => {
  const theme = useTheme();
  const showModal = useToggle(false);
  const showSessionExpiredModal = useToggle(false);
  const [billpaySkeleton, setBillpaySkeleton] = useState(false);
  const openAccountCheck = useToggle(false);
  const openJourneyPicker = useToggle(false);
  const openKeepNumberCheck = useToggle(false);
  const upgradeIneligible = useToggle(false);
  const openHandleThirdOfferSelect = useToggle(false);
  const openAPIFailureModal = useToggle(false);
  const isR6Customer = useToggle(false);
  const upgradeErrorModal = useToggle(false);
  const addMobileCSModal = useToggle(false);
  const enableWebChat = useToggle(false);
  const [openError, setOpenError] = useState(false);
  const [loginModal, setLoginModal] = useState(false);
  const [loader, setLoader] = useState(false);
  const [onLoadingDisablecta, setOnLoadingDisablecta] = useState(false);
  const [customerEligibility, setCustomerEligibility] = useState({});
  const [hasExistingBillPay, setHasExistingBillPay] = useState(false);
  const [errorModalOccurence, setErrorModalOccurence] = useState(0);
  const errorModalMaxOccurence = 1;
  const errorModal = useToggle(false);
  const registrationIncompleteModal = useToggle(false);
  const [onLoadError, setOnLoadError] = useState(false);
  const [journeyCrossOver, setJourneyCrossOver] = useState(false);
  const router = useRouter();
  const localStore = useLocalStorage();
  const { hasValue } = localStore;
  const [state, setState] = useState({
    offers: [],
    devices: [],
    brands: [],
    discounts: [],
    selectedMobileOffer: null,
    simOnly: localStore.getLocalStorage('BILLPAY_JOURNEY') !== 'true',
    // simOnly: false,
  });
  const [loading, setLoading] = useState({ offerData: true, deviceData: true });
  const graphql = useApolloClient();
  const { state: rootState, dispatch } = useContext(RootContext);
  const [controlBackButton, setControlBackButton] = useState(true);
  // const [fadeEffect, setFadeEffect] = useState(false);
  const [showLoader, setShowLoader] = useState(' ');
  const [existingCustomerCheckValue, setExistingCustomerCheckValue] = useState(false);
  const [getSIMOnly, setSIMOnly] = useState(false);
  const [eligibleForNone, setEligibleForNone] = useState(false);
  const openAbondonModal = useToggle(false);
  const mfaOtpModal = useToggle(false);
  const mfaSuccessModal = useToggle(false);
  const [clearJourney, setClearJourney] = useState(false);
  const [journeyType, setJourneyType] = useState('');
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
  const [coMobileSubscriptions, setCoMobileSubscriptions] = useState([]);
  const [hidePortAccordian, setHidePortAccordian] = useState(
    getCookie('cart_Type') === 'CHANGE_OFFER'
  );
  const sm = useMediaQuery(theme.breakpoints.down('sm'));
  const [dropdownContent, setDropdownContent] = useState([]);
  const [subscriptionId, setSubscriptionId] = useState();
  const [isBillPayParam, setIsBillPayParam] = useState('false');
  const [isSimonlyParam, setIsSimonlyParam] = useState('false');
  const [otpUUID, setOtpUUID] = useState('');
  const [userValue, setUserValue] = useState('');
  const [delivery, setDelivery] = useState('');

  const nextButtonAction = () => {
    if (localStore.getLocalStorage('portIn') === 'true') {
      localStore.setLocalStorage('INCOMPLETE_PORTING', true);
      if (getCookie('cart_Type') === 'CHANGE_OFFER')
        router.push(`${publicRuntimeConfig.NEXT_PUBLIC_PATH}/mobile/porting`);
    } else {
      localStore.removeLocalStorage('INCOMPLETE_PORTING');
      if (getCookie('cart_Type') === 'CHANGE_OFFER')
        router.push(`${publicRuntimeConfig.NEXT_PUBLIC_PATH}/redirectSummary`);
    }
  };
  const continueButtonAction = () => {
    if (localStore.getLocalStorage('portIn') === 'true') {
      localStore.setLocalStorage('INCOMPLETE_PORTING', true);
      router.push(`${publicRuntimeConfig.NEXT_PUBLIC_PATH}/mobile/porting`);
    } else {
      localStore.removeLocalStorage('INCOMPLETE_PORTING');
      router.push(`${publicRuntimeConfig.NEXT_PUBLIC_PATH}/redirectSummary`);
    }
  };

  // on change in portin value
  const onPortingChange = async (portIn, simOnly) => {
    setLoading({ ...loading, offerData: true });
    setState({ ...state, offers: [] });
    const offerData = await onPortingChangeService({ graphql, portIn, simOnly, localStore });
    viewItemListAnalytics('Mobile_SIMO_Tariffs', offerData?.offers);
    setState({ ...state, offers: offerData?.offers, discounts: offerData?.discounts });
    setLoading({ ...loading, offerData: false });
    // if (fadeEffect) setFadeEffect(false);
  };

  // const mobileSubscriptions = eligibility?.subscriptions?.filter(
  //   subscription => subscription.serviceGroup === 'MOBILE'
  // );

  // const handleLogin = () => {
  //   setLoginModal(true);
  // };

  // on offer unselect
  const onOfferUnSelect = async setUnSelected => {
    try {
      const data = await onOfferCardUnSelected({
        graphql,
        localStorage: localStore,
        cart: rootState.cart,
      });
      if (data != null && !data.error) {
        setUnSelected(true);
        removeFromCartAnalytics(data);
        dispatch({ type: 'SET_CART', payload: data });
        displayCart({
          dispatch,
          localStorage: localStore,
          graphql,
          cart: data,
          showNextButton: false,
          handleMobileOnloadDisplay:
            data?.offers?.filter(x => x.baseOffer.serviceGroup === 'MOBILE').length === 0,
        });
        setState({
          ...state,
          selectedMobileOffer: null,
        });
        setErrorModalOccurence(0);
        errorModal.disable();
        setOnLoadError(false);
      } else {
        setUnSelected(false);
        setOnLoadError(false);
        if (!getCookie('token-missing') && !getCookie('found-403')) setOpenError(true);
        setCookie('ION', 'API_FAILED', 'onOfferUnSelect');
        if (!getCookie('token-missing') && !getCookie('found-403')) openAPIFailureModal.enable();
        if (!getCookie('token-missing') && !getCookie('found-403'))
          setErrorModalOccurence(errorModalOccurence + 1);
        if (!getCookie('found-403')) errorModal.enable();
        if (!getCookie('token-missing')) errorModal.enable();
        setShowLoader(' ');
      }
      // setLoading({ ...loading, deviceData: false });

      return data;
    } catch (err) {
      setUnSelected(false);
      setOnLoadError(false);
      if (!getCookie('token-missing') && !getCookie('found-403')) setOpenError(true);
      if (!getCookie('token-missing') && !getCookie('found-403'))
        setErrorModalOccurence(errorModalOccurence + 1);
      if (!getCookie('found-403')) errorModal.enable();
      if (!getCookie('token-missing')) errorModal.enable();
      setCookie('ION', 'API_FAILED', 'onOfferUnSelect');
      if (!getCookie('token-missing') && !getCookie('found-403')) openAPIFailureModal.enable();
      setShowLoader(' ');
    }
  };

  // on Offer Select
  const onOfferSelect = async (tariff, simOnly, setSelected) => {
    if (
      rootState?.cart?.offers.filter(offer => offer?.baseOffer?.serviceGroup === 'MOBILE').length >
        0 &&
      !localStore.hasValue('INCOMPLETE_CART') &&
      !localStore.hasValue('INCOMPLETE_PORTING') &&
      localStore.hasValue('ADDITIONAL_OFFERS_ALLOWED') &&
      localStore.getLocalStorage('ADDITIONAL_OFFERS_ALLOWED') === 'false' &&
      getCookie('cart_Type') !== 'CHANGE_OFFER'
    ) {
      openHandleThirdOfferSelect.enable();
    } else {
      // if a tariff is already in cart.
      // if (selectedBundle) {
      //   const response = await onOfferUnSelect();
      // }
      setShowLoader(tariff.code);
      setLoading({ ...loading, deviceData: true });
      try {
        const data = await onOfferCardSelected({
          graphql,
          selectedOffer: tariff,
          localStorage: localStore,
          cart: rootState.cart,
        });
        if (data != null && !data.error) {
          addToCartAnalytics(data);
          dispatch({ type: 'SET_CART', payload: data });
          displayCart({
            dispatch,
            localStorage: localStore,
            graphql,
            nextMethod: nextButtonAction,
            disablenNextButton: !simOnly,
            showNextButton: false,
            cart: data,
          });
          setSelected(true);
          setShowLoader(' ');
          if (simOnly) {
            localStore.removeLocalStorage('BILLPAY_JOURNEY');
            setState({
              ...state,
              selectedMobileOffer: data ? tariff : '',
            });

            nextButtonAction();
          } else {
            const { result, error } = await onGetHandsets({
              graphql,
              localStorage: localStore,
              cart: data,
            });
            if (result && !error) {
              setState({
                ...state,
                selectedMobileOffer: data ? tariff : '',
                devices: result.getHandsets.handsets,
                brands: result.getHandsets.manufacturers,
              });
            } else {
              console.error('something went wrong getting handsets,', error);
            }
          }
          setErrorModalOccurence(0);
          errorModal.disable();
        } else {
          setSelected(false);
          if (!getCookie('token-missing') && !getCookie('found-403')) setOpenError(true);
          setOnLoadError(false);
          setCookie('ION', 'API_FAILED', 'onOfferSelect');
          if (!getCookie('token-missing') && !getCookie('found-403')) openAPIFailureModal.enable();
          setShowLoader(' ');
          if (!getCookie('token-missing') && !getCookie('found-403'))
            setErrorModalOccurence(errorModalOccurence + 1);
          if (!getCookie('found-403')) errorModal.enable();
          if (!getCookie('token-missing')) errorModal.enable();
        }
        setLoading({ ...loading, deviceData: false });
      } catch (err) {
        setSelected(false);
        if (!getCookie('token-missing') && !getCookie('found-403')) setOpenError(true);
        setOnLoadError(false);
        if (!getCookie('token-missing') && !getCookie('found-403'))
          setErrorModalOccurence(errorModalOccurence + 1);
        if (!getCookie('found-403')) errorModal.enable();
        if (!getCookie('token-missing')) errorModal.enable();
        setCookie('ION', 'API_FAILED', 'onOfferSelect');
        if (!getCookie('token-missing') && !getCookie('found-403')) openAPIFailureModal.enable();
        setShowLoader(' ');
      }
    }
  };
  // on button toggle
  const onSimoToggle = async simOnly => {
    setLoading({ ...loading, offerData: true });
    setState({ ...state, offers: [] });
    setBillpaySkeleton(!billpaySkeleton);
    const offerData = await getTariffWithSimo({
      graphql,
      simOnly: localStore.getLocalStorage('GET_SIMONLY') ? true : simOnly,
      localStorage: localStore,
    });
    setState(prevState => ({
      ...prevState,
      simOnly,
      offers: offerData?.offers,
      discounts: offerData?.discounts,
    }));
    setLoading({ ...loading, offerData: false });
    viewItemListAnalytics('Mobile_Billpay_Tariffs', offerData?.offers);
    dispatch({ type: 'SET_BILLPAY_TOGGLE', payload: false });
  };
  useEffect(() => {
    if (getCookie('PREPAY_REFERENCE')) {
      clearAllCookies();
      localStorage.clear();
    }
  }, []);
  // const mobileEligibilityCheck = subs => {
  //   const mobileSubscriptions = subs?.subscriptions?.filter(
  //     subscription => subscription.serviceGroup === 'MOBILE'
  //   );
  //   const notEligibleMobile = mobileSubscriptions.filter(
  //     mobileSub => mobileSub.coEligiblity.changeOffer === false
  //   );
  //   console.log('===notEligibleMobile', notEligibleMobile);
  //   console.log('===mobileSubscriptions', mobileSubscriptions);
  //   if (notEligibleMobile.length === mobileSubscriptions.length) {
  //     setEligibleForNone(true);
  //   } else {
  //     openJourneyPicker.enable();
  //   }
  // };

  const crossSellJourney = async custEligibility => {
    const filteredMobileSubs = custEligibility?.subscriptions?.filter(
      sg => sg?.serviceGroup === MOBILE
    );

    const accountId = getCookie('account_Id');
    if (accountId) {
      if (getCookie('channel') !== 'MYEIR') {
        const result = await createCrossSellProspect({
          graphql,
          accountId,
          offerType: 'POSTPAY',
        });
        openJourneyPicker.disable();
        if (result) {
          setLoginModal(false);
          if (filteredMobileSubs?.length > 0) {
            upgradeIneligible.enable();
          } else {
            openKeepNumberCheck.enable();
          }
        }
      } else {
        openKeepNumberCheck.enable();
      }
    }
  };
  const getChangeMobileOfferTarrif = async simOnly => {
    setLoading({ ...loading, offerData: true });
    setState({ ...state, offers: [] });
    const {
      offers = [],
      selectedMobileOffer,
      handsetList,
      brandList,
      cartData,
      discounts,
    } = await getCoTarrif({ graphql, simOnly, localStorage: localStore, dispatch });
    console.log('simOnly', simOnly);
    if (selectedMobileOffer?.offer) {
      setState({
        ...state,
        offers,
        discounts,
        devices: handsetList,
        brands: brandList,
        selectedMobileOffer: selectedMobileOffer?.offer,
        simOnly,
      });
      displayCart({
        cart: cartData,
        dispatch,
        localStorage: localStore,
        graphql,
        showNextButton: false,
      });
      setLoading({ ...loading, offerData: false, deviceData: false });
    } else {
      setState({
        ...state,
        offers,
        discounts,
        simOnly,
      });
      setLoading({ ...loading, offerData: false });
    }
    // setState({ ...state, offers: offerData?.offers, discounts: offerData?.discounts });
  };

  // below method is for reference
  // const getChangeMobileOfferTarrif = async simOnly => {
  //   console.log('--in getchange simOnly', simOnly);
  //   setLoading({ ...loading, offerData: true });
  //   setState({ ...state, offers: [] });
  //   const offerData = await getCoTarrif({ graphql, simOnly, localStorage: localStore });
  //   setState({ ...state, offers: offerData?.offers, discounts: offerData?.discounts });
  //   setLoading({ ...loading, offerData: false });
  // };
  const changeOfferJourney = async id => {
    if (id) {
      const result = await changeOfferMobileRequest({
        graphql,
        subscriptionId: id,
        channel: 'ESHOP', // only ESHOP works for create change Offer
        email: getCookie('email_Address'),
      });
      if (result) {
        let existingCOPlan = customerEligibility?.subscriptions?.filter(sub => sub.id === id)[0];
        if (!existingCOPlan) {
          const CustomerEligibility = await mobileEligibilityCheck({
            token: getTokenFromCookies(),
          });
          existingCOPlan = CustomerEligibility?.subscriptions?.filter(sub => sub.id === id)[0];
        }
        if (existingCOPlan.simOnly) {
          getChangeMobileOfferTarrif(state.simOnly);
        } else {
          getChangeMobileOfferTarrif(false);
          setHasExistingBillPay(true);
          setBillpaySkeleton(true);
        }
        setHidePortAccordian(true);
        setShowSubscriptionModal(false);
        setSubscriptionId(id);
      }
    } else {
      setHidePortAccordian(false);
      crossSellJourney();
    }
  };

  const onMobileJourneyLogin = async () => {
    let Eligibility = eligibility;
    Eligibility = eligibility.constructor !== Object ? JSON.parse(eligibility) : eligibility;
    if (Object.keys(Eligibility).length !== 0) setCustomerEligibility(Eligibility);
    if (Object.keys(Eligibility).length === 0 && Eligibility.constructor === Object) {
      if (getTokenFromCookies() && !getCookie('cart_Type')) {
        const CustomerEligibility = await mobileEligibilityCheck({ token: getTokenFromCookies() });
        if (Object.keys(CustomerEligibility?.contactDetails || {}).length === 0) {
          setLoginModal(false);
          setOnLoadError(true);
          setErrorModalOccurence(errorModalOccurence + 1);
          if (!getCookie('found-403')) errorModal.enable();
          if (!getCookie('token-missing')) errorModal.enable();
          openJourneyPicker.disable();
          return;
        }

        /* Below lines are commented for ChangeOffer removal */

        const filteredMobileSubs = CustomerEligibility?.subscriptions?.filter(
          sg => sg?.serviceGroup === 'MOBILE'
        );
        const coMobileEligible = filteredMobileSubs?.filter(
          ele =>
            ele?.coEligiblity?.contractRenewal === true &&
            ele?.coEligiblity?.earlyCeaseChargeList?.totalAmountVatIncluded <= 0
        );
        // If user is eligible for Co and cs both then open Journey picker,
        // else if only cs and no co then directly start cs journey,
        // else start only co journey---> if co =1 then directly start co journey else open subscription modal.
        if (!(coMobileEligible?.length > 0)) {
          if (
            CustomerEligibility?.crossSellEligibility?.serviceGroups?.filter(
              servicegrp => servicegrp.serviceGroup === 'MOBILE'
            )[0]?.eligible
          ) {
            setLoginModal(false);
            openJourneyPicker.disable();
            crossSellJourney(CustomerEligibility);
          } else {
            setLoginModal(false);
            enableWebChat.enable();
          }
        } else if (
          CustomerEligibility?.crossSellEligibility?.serviceGroups?.filter(
            servicegrp => servicegrp.serviceGroup === 'MOBILE'
          )[0]?.eligible
        ) {
          setCoMobileSubscriptions(coMobileEligible);
          fillDropdown({ mobileSubscription: coMobileEligible, setDropdownContent });
          setCustomerEligibility(CustomerEligibility);
          setLoginModal(false);
          openJourneyPicker.enable();
        } else {
          // code to be written to start with only CO Mobile Journey without CS
          setCoMobileSubscriptions(coMobileEligible);
          fillDropdown({ mobileSubscription: coMobileEligible, setDropdownContent });
          setCustomerEligibility(CustomerEligibility);
          setLoginModal(false);

          if (coMobileEligible?.length > 1) {
            setShowSubscriptionModal(true);
          } else {
            changeOfferJourney(coMobileEligible[0].id);
          }
        }

        // mobileEligibilityCheck(eligibility);
      }
    } else if (getTokenFromCookies() && !getCookie('cart_Type')) {
      // const CustomerEligibility = await eligibilityCheck({ token: getTokenFromCookies() });
      if (Object.keys(Eligibility?.contactDetails || {}).length === 0) {
        setOnLoadError(true);
        setErrorModalOccurence(errorModalOccurence + 1);
        if (!getCookie('found-403')) errorModal.enable();
        if (!getCookie('token-missing')) errorModal.enable();
        openJourneyPicker.disable();
        return;
      }
      /* Below lines are commented for ChangeOffer removal */

      const filteredMobileSubs = Eligibility?.subscriptions?.filter(
        sg => sg?.serviceGroup === 'MOBILE'
      );
      const coMobileEligible = filteredMobileSubs?.filter(
        ele =>
          ele?.coEligiblity?.contractRenewal === true &&
          ele?.coEligiblity?.earlyCeaseChargeList?.totalAmountVatIncluded <= 0
      );
      // If user is eligible for Co and cs both then open Journey picker,
      // else if only cs and no co then directly start cs journey,
      // else start only co journey---> if co =1 then directly start co journey else open subscription modal.
      if (!coMobileEligible?.length > 0) {
        if (
          Eligibility?.crossSellEligibility?.serviceGroups?.filter(
            servicegrp => servicegrp.serviceGroup === 'MOBILE'
          )[0]?.eligible
        ) {
          setLoginModal(false);
          openJourneyPicker.disable();
          crossSellJourney(Eligibility);
        } else {
          setLoginModal(false);
          enableWebChat.enable();
        }
      } else if (
        Eligibility?.crossSellEligibility?.serviceGroups?.filter(
          servicegrp => servicegrp.serviceGroup === 'MOBILE'
        )[0]?.eligible
      ) {
        setCoMobileSubscriptions(coMobileEligible);
        fillDropdown({ mobileSubscription: coMobileEligible, setDropdownContent });
        setCustomerEligibility(Eligibility);
        setLoginModal(false);
        openJourneyPicker.enable();
      } else {
        // code to be written to start with only CO Mobile Journey without CS
        // setCoMobileSubscriptions(coMobileEligible);
        // fillDropdown(coMobileEligible);
        // setCustomerEligibility(Eligibility);
        // setLoginModal(false);
        setCoMobileSubscriptions(coMobileEligible);
        fillDropdown({ mobileSubscription: coMobileEligible, setDropdownContent });
        setCustomerEligibility(Eligibility);
        setLoginModal(false);

        if (coMobileEligible?.length > 1) {
          setShowSubscriptionModal(true);
        } else {
          changeOfferJourney(coMobileEligible[0].id);
        }
      }

      // mobileEligibilityCheck(eligibility);
    }
  };

  const onPageLoad = async () => {
    if (!openAbondonModal.value) {
      if (localStore.getLocalStorage('HANDSET_BE_OFFERID')) {
        if (getCookie('cart_type') === 'CHANGE_OFFER') {
          const offerId = parseInt(localStore.getLocalStorage('HANDSET_BE_OFFERID'), 10);
          const result = await removeTariff(graphql, offerId, 'CHANGE_OFFER');
          if (result) {
            localStore.removeLocalStorage('HANDSET_BE_OFFERID');
            localStore.removeLocalStorage('STANDALONE_HANDSET');
          }
        }
      }
      const queryParameters = new URLSearchParams(window.location.search);
      const billPayParam = queryParameters.get('billpay');
      const simOnlyParam = queryParameters.get('simonly');
      if (simOnlyParam === 'true') {
        localStore.removeLocalStorage('BILLPAY_JOURNEY');
      }
      setLoading({ ...loading, offerData: true });
      const {
        offers = [],
        selectedMobileOffer,
        handsetList,
        brandList,
        cartData,
        discounts,
      } = await onload({
        graphql,
        localStorage: localStore,
        dispatch,
        SecondBillPayPlanNeeded:
          localStore.getLocalStorage('BILLPAY_JOURNEY') ||
          billPayParam === 'true' ||
          hasExistingBillPay,
      });
      if (hasValue('GET_SIMONLY')) {
        displayCart({
          cart: cartData,
          dispatch,
          localStorage: localStore,
          graphql,
          showNextButton: false,
        });
      }
      if (
        localStore.getLocalStorage('BILLPAY_JOURNEY') ||
        billPayParam === 'true' ||
        hasExistingBillPay
      ) {
        setState({
          ...state,
          offers,
          discounts,
          devices: handsetList,
          brands: brandList,
          selectedMobileOffer: selectedMobileOffer?.offer,
          simOnly: false,
        });
      } else {
        setState({
          ...state,
          offers,
          discounts,
          devices: handsetList,
          brands: brandList,
          selectedMobileOffer: selectedMobileOffer?.offer,
          simOnly:
            localStore.getLocalStorage('GET_SIMONLY') || simOnlyParam === 'true'
              ? true
              : Boolean(selectedMobileOffer?.simOnly),
        });
      }
      if (cartData !== undefined && cartData?.offers?.length > 0) {
        displayCart({
          cart: cartData,
          // showCart: true,
          dispatch,
          localStorage: localStore,
          graphql,
          nextMethod: nextButtonAction,
          disablenNextButton: Boolean(!selectedMobileOffer?.simOnly),
          showNextButton: false,
          handleMobileOnloadDisplay:
            cartData?.offers?.filter(x => x.baseOffer.serviceGroup === 'MOBILE').length === 0 ||
            Object?.keys(cartData || '{}')?.length === 0,
        });
      }
      setLoading({ ...loading, offerData: false, deviceData: false });
      if (!offers) {
        setOnLoadError(true);
        if (!getCookie('token-missing') && !getCookie('found-403')) setOpenError(true);
        if (!getCookie('token-missing') && !getCookie('found-403'))
          setErrorModalOccurence(errorModalOccurence + 1);
        if (!getCookie('found-403')) errorModal.enable();
        if (!getCookie('token-missing')) errorModal.enable();
        if (!getCookie('token-missing') && !getCookie('found-403')) openAPIFailureModal.enable();
      }
      setHasExistingBillPay(false);
    }
  };

  useEffect(() => {
    if (hasExistingBillPay) {
      onPageLoad();
    }
  }, [hasExistingBillPay]);

  useEffect(() => {
    const queryParameters = new URLSearchParams(window.location.search);
    const queryParamBillPay = queryParameters.get('billpay');
    const queryParamSimOnly = queryParameters.get('simonly');

    if (queryParamBillPay === 'true' && queryParamBillPay !== isBillPayParam) {
      setIsBillPayParam(queryParamBillPay);
      onPageLoad();
    } else if (queryParamBillPay !== 'true') {
      setIsBillPayParam('false');
    }

    if (queryParamSimOnly === 'true' && queryParamSimOnly !== isSimonlyParam) {
      setIsSimonlyParam(queryParamSimOnly);
      onPageLoad();
    } else if (queryParamSimOnly !== 'true') {
      setIsSimonlyParam('false');
    }
  });

  useEffect(() => {
    if (journeyCrossOver) {
      // openKeepNumberCheck.disable();
      // openJourneyPicker.enable();
      onMobileJourneyLogin();
      setJourneyCrossOver(false);
    }
  }, [journeyCrossOver]);
  useEffect(() => {
    if (coMobileSubscriptions?.length > 0) {
      fillDropdown({ mobileSubscription: coMobileSubscriptions, setDropdownContent });
      setSubscriptionId(parseInt(getCookie('SUBSCRIPTION_ID'), 10));
    }
  }, [coMobileSubscriptions]);

  useEffect(() => {
    if (rootState.displayLogin) {
      setLoginModal(true);
    }
  }, [rootState]);
  const fetchPageInfo = async () => {
    const { openAccountCheckModal, openKeepNumberCheckModal, openAbondonCheckModal } =
      onLoadValuesInitializer({
        journeyData,
        setCode,
        getTokenFromCookies,
        dispatch,
        localStore,
        setControlBackButton,
        setExistingCustomerCheckValue,
        hasLocalStorageValue,
        getCookie,
        setJourneyType,
        setHidePortAccordian,
      });

    const {
      loadJourneyPickerModal,
      isCrossSellEligible,
      isChangeOfferEligible,
      isOnlyCrossSellEligible,
    } = await crossSellOrChangeOfferOnLoadEligibilityChecker({
      eligibility,
      getTokenFromCookies,
      hasLocalStorageValue,
      getCookie,
      setCookie,
      getLocalStorage: localStore.getLocalStorage,
      setCoMobileSubscriptions,
      mobileEligibilityCheck,
      setCustomerEligibility,
      setDropdownContent,
    });

    if (getCookie('MYEIR_TV_ADDED')) {
      addMobileCSModal.enable();
    } else if (openAccountCheckModal) openAccountCheck.enable();
    else if (openAbondonCheckModal) openAbondonModal.enable();
    else if (
      isOnlyCrossSellEligible &&
      getCookie('channel') !== 'MYEIR' &&
      openKeepNumberCheckModal
    ) {
      const userEligibility = eligibility && JSON.parse(eligibility);
      const filteredMobileSubs = userEligibility?.subscriptions?.filter(
        sg => sg?.serviceGroup === MOBILE
      );
      if (filteredMobileSubs?.length > 0) {
        upgradeIneligible.enable();
      } else {
        openKeepNumberCheck.enable();
      }
    } else if (
      openKeepNumberCheckModal &&
      !loadJourneyPickerModal &&
      !isCrossSellEligible &&
      !openAbondonCheckModal &&
      !isChangeOfferEligible.value
    )
      openKeepNumberCheck.enable();
    else if (loadJourneyPickerModal) openJourneyPicker.enable();
    else if (isCrossSellEligible && !openAbondonCheckModal) {
      if (getCookie('MYEIR_TV_ADDED')) {
        addMobileCSModal.enable();
      } else {
        crossSellJourney();
      }
    } else if (isChangeOfferEligible.value && !openAbondonCheckModal) {
      console.log('outside journeyData', journeyData);
      getChangeMobileOfferTarrif(false);
      // console.log('outside journeyData', journeyData);
      // if (journeyData) {
      //   // getChangeMobileOfferTarrif(false);
      //   getChangeMobileOfferTarrif(false);
      //   console.log('outside journeyData', journeyData);
      // } else if (isChangeOfferEligible?.CoEligiblenumber === 1) {
      //   // changeOfferJourney(isChangeOfferEligible?.coEligiblityDetails[0].id);
      //   getChangeMobileOfferTarrif(false);
      // } else {
      //   // changeOfferJourney(parseInt(getCookie('SUBSCRIPTION_ID'), 10));
      //   getChangeMobileOfferTarrif(false);
      // }
    } else if (hasValue('GET_SIMONLY')) {
      setSIMOnly(true);
      if (getCookie('MYEIR_TV_ADDED')) {
        addMobileCSModal.enable();
      } else onPageLoad();
    } else onPageLoad();
  };

  useEffect(() => {
    setLoading({ ...loading, offerData: true });
    fetchPageInfo();
  }, []);

  useEffect(() => {
    if (getCookie('BILL_TYPE') === 'Fixed_Bill') {
      isR6Customer.enable();
    }
  }, []);
  useEffect(() => {
    const token = getTokenFromCookies();
    if (getCookie('CHANNEL') === 'MYEIR' && token) {
      openAccountCheck.disable();
    }
  }, []);

  useEffect(() => {
    const localRepoItems = getCookie('found-403');
    if (localRepoItems === 'true') {
      showModal.enable();
    } else {
      showModal.disable();
    }
    const expiredRepoItems = getCookie('token-missing');
    if (expiredRepoItems === 'true') {
      showSessionExpiredModal.enable();
    } else {
      showSessionExpiredModal.disable();
    }
  });
  return (
    <Stack
      sx={{
        backgroundSize: '100%',
        backgroundColor: theme.palette.primary.backgroundColor2,
        minHeight: '100vh',
      }}
    >
      <EirMetaTag seo={cmsData?.data?.attributes?.Seo_Mobile} />
      <EirHeader cmsHeaderData={cmsHeaderData?.data} />
      {!hasLocalStorageValue('ION_EXISTING_CUSTOMER') &&
        !hasValue('portIn') &&
        !(getCookie('channel') === 'MYEIR') && (
          <ExistingCustomerCheck
            openAccountCheck={openAccountCheck}
            openKeepNumberCheck={openKeepNumberCheck}
            setExistingCustomerCheckValue={setExistingCustomerCheckValue}
            setLoginModal={setLoginModal}
            graphql={graphql}
            dispatch={dispatch}
          />
        )}
      <main id='main' tabIndex={-1}>
        {loginModal && (
          <LoginModal
            enable={loginModal}
            setEnableModal={setLoginModal}
            registrationIncompleteModal={registrationIncompleteModal}
            mfaOtpModal={mfaOtpModal}
            mfaSuccessModal={mfaSuccessModal}
            setOtpUUID={setOtpUUID}
            setUserValue={setUserValue}
            setDelivery={setDelivery}
            onload={onMobileJourneyLogin}
            mobile
            saveLoginInfo={dispatch}
            showLoader={loader}
            setShowLoader={setLoader}
            loaderText='logging in'
            onLoadingDisablecta={onLoadingDisablecta}
            setOnLoadingDisablecta={setOnLoadingDisablecta}
            isR6Customer={isR6Customer}
            openAccountCheck={openAccountCheck}
          />
        )}
        {mfaOtpModal.value && (
          <MfaOtpModal
            mfaOtpModal={mfaOtpModal}
            userValue={userValue}
            delivery={delivery}
            errorModal={errorModal}
            otpUUID={otpUUID}
            setOtpUUID={setOtpUUID}
            mfaSuccessModal={mfaSuccessModal}
          />
        )}
        {mfaSuccessModal.value && <MfaSuccessModal mfaSuccessModal={mfaSuccessModal} />}
        {registrationIncompleteModal.value && (
          <EirRegistrationRequiredModal registrationIncompleteModal={registrationIncompleteModal} />
        )}

        {openJourneyPicker.value && (
          <EirJourneyPickerModal
            customerEligibility={customerEligibility}
            openJourneyPicker={openJourneyPicker}
            openKeepNumberCheck={openKeepNumberCheck}
            graphql={graphql}
            cmsData={cmsData?.data}
            upgradeErrorModal={upgradeErrorModal}
            setShowSubscriptionModal={setShowSubscriptionModal}
            coMobileSubscriptions={coMobileSubscriptions}
            changeOfferJourney={changeOfferJourney}
            setHidePortAccordian={setHidePortAccordian}
          />
        )}
        {upgradeIneligible.value && (
          <MobileUpgradeIneligibleModal
            customerEligibility={customerEligibility}
            openKeepNumberCheck={openKeepNumberCheck}
            upgradeIneligible={upgradeIneligible}
          />
        )}

        {openKeepNumberCheck.value && (
          <KeepNumberModal
            openKeepNumberCheck={openKeepNumberCheck}
            simOnly={state.simOnly}
            onPortingChange={onPortingChange}
            cmsData={cmsData?.data}
          />
        )}

        {/* <NotificationBanner
        desktopText={
          <p>
            <span style={{ fontWeight: 700 }}>
              {cmsDataLoginBanner?.data?.attributes?.desktopDescriptionFirstHalf}
            </span>{' '}
            {cmsDataLoginBanner?.data?.attributes?.desktopDescriptionSecondHalf}
          </p>
        }
        mobileText={cmsDataLoginBanner?.data?.attributes?.mobileDescription}
        cta={{
          ctaText: 'Log in to see deals',
          type: 'solid',
          action: () => handleLogin(),
          disableCta: false,
        }}
      /> */}
        <NavBar
          backButtonText='Back'
          forwardButtonText='Checkout'
          forwardArrowIcon={
            <ArrowForward sx={{ m: 0, color: theme.palette.secondary.contrastText }} />
          }
          backArrowIcon={<ArrowBack sx={{ m: 0, color: theme.palette.secondary.contrastText }} />}
          backButtonOnClick={() => {
            backStep({ router });
          }}
          nextButtonOnClick={() => {
            nextStep({ router });
          }}
          disableBack={controlBackButton}
          disableNext={false}
          // fadeEffect={fadeEffect}
          additionalStyles={getCookie('cart_Type') === 'CHANGE_OFFER'}
          headerText={
            hidePortAccordian && (
              <>
                <NavBarTitle
                  title='Which mobile would you like to change?'
                  style={
                    !sm && {
                      title: { marginRight: '32px' },
                    }
                  }
                />{' '}
                <MobileDropDownMenu
                  numbers={dropdownContent}
                  changeOfferJourney={changeOfferJourney}
                  additionalStyles
                  setSubscriptionId={setSubscriptionId}
                  subscriptionId={subscriptionId}
                  disableAltcta={
                    !customerEligibility?.crossSellEligibility?.serviceGroups?.filter(
                      servicegrp => servicegrp.serviceGroup === 'MOBILE'
                    )[0]?.eligible
                  }
                />
              </>
            )
          }
        />
        <Grid container justifyContent='center'>
          <Grid item xs={12}>
            <MobileOfferContainer
              billpaySkeleton={billpaySkeleton}
              contentCarousel={contentCarousel}
              cmsData={cmsData.data}
              offers={state.offers}
              discounts={state.discounts}
              simOnly={state.simOnly}
              openKeepNumberCheck={openKeepNumberCheck}
              onPortingChange={onPortingChange}
              onSimoToggle={onSimoToggle}
              onOfferSelect={onOfferSelect}
              onOfferUnSelect={onOfferUnSelect}
              loading={loading.offerData}
              selectedBundle={state.selectedMobileOffer}
              // fadeEffect={fadeEffect}
              // setFadeEffect={setFadeEffect}
              showLoader={showLoader}
              existingCustomerCheckValue={existingCustomerCheckValue}
              getSIMOnly={getSIMOnly}
              hidePortAccordian={hidePortAccordian}
            />
          </Grid>
          {getCookie('cart_Type') !== 'CHANGE_OFFER' &&
            state.selectedMobileOffer &&
            state.simOnly && (
              <SimoSimTypeContainer
                cmsData={cmsData.data}
                continueButtonAction={continueButtonAction}
                cart={rootState.cart}
              />
            )}
          {Boolean(state.selectedMobileOffer) && !state.simOnly && state.devices && (
            <Grid item xs={12}>
              <EirDeviceContainer
                devices={state.devices}
                brands={state.brands}
                loading={loading.deviceData}
                cmsData={cmsData.data}
              />
            </Grid>
          )}
        </Grid>
        {cmsData?.data?.attributes?.Mobile_FAQ_List.length > 0 && (
          <Grid
            xs={12}
            sx={{
              background: theme.palette.primary.backgroundColor3,
              ...styles(theme).faqContainerSuperMain,
            }}
          >
            <FaqContainer
              InsuranceHeading={cmsData?.data?.attributes?.Mobile_FAQ_Title}
              InsuranceList={cmsData?.data?.attributes?.Mobile_FAQ_List}
            />
          </Grid>
        )}
        {openError && errorModalOccurence > errorModalMaxOccurence && (
          <ApiFailureModal openAPIFailureModal={openAPIFailureModal} handleOk={handleOk} />
        )}
        {showSubscriptionModal && (
          <SubscriptionSelectionModal
            titleName={customerEligibility?.contactDetails?.firstName}
            disableAltcta={
              !customerEligibility?.crossSellEligibility?.serviceGroups?.filter(
                servicegrp => servicegrp.serviceGroup === 'MOBILE'
              )[0]?.eligible
            }
            mobile
            subscriptions={coMobileSubscriptions}
            cmsData={cmsData?.data}
            changeOfferJourney={changeOfferJourney}
            mobileSubscription
            openKeepNumberCheck={openKeepNumberCheck}
            customerEligibility={customerEligibility}
            graphql={graphql}
            setShowSubscriptionModal={setShowSubscriptionModal}
          />
        )}
        {showModal.value && <LoginMain403 />}
        {showSessionExpiredModal !== undefined && showSessionExpiredModal.value && (
          <SessionExpireModal confirmLogOut={showSessionExpiredModal} />
        )}
        {errorModal.value && !showModal.value && !showSessionExpiredModal.value && (
          <ErrorModal
            errorBBModal={errorModal}
            occurences={errorModalMaxOccurence}
            currentOccurence={errorModalOccurence}
            ctaMethod={onLoadError ? onPageLoad : () => {}}
          />
        )}
        {eligibleForNone && (
          <NoEligibilityErrorModal
            eligibleForNone={eligibleForNone}
            setEligibleForNone={setEligibleForNone}
          />
        )}
        {enableWebChat.value && <EirWebchatModal enableWebChat={enableWebChat} />}
        {openAbondonModal.value && (
          <EirAbondonJourney
            openAbondonModal={openAbondonModal}
            cmsData={cmsData}
            setClearJourney={setClearJourney}
            clearJourney={clearJourney}
            setJourneyType={setJourneyType}
            mobile
            setJourneyCrossOver={setJourneyCrossOver}
            journeyType={journeyType}
          />
        )}
        {openHandleThirdOfferSelect.value && (
          <ThirdMobileOfferSelectModal openHandleThirdOfferSelect={openHandleThirdOfferSelect} />
        )}

        {upgradeErrorModal.value && (
          <UpgradeMobileErrorModal upgradeErrorModal={upgradeErrorModal} />
        )}

        {isR6Customer.value && <UANErrorModal isMobile errorUANModal={isR6Customer} />}
        {/* {isR6Customer.value && <BillingCheckErrorModal isR6Customer={isR6Customer} />} */}
        {addMobileCSModal.value && (
          <AddMobileCsModal addMobileCSModal={addMobileCSModal} onPageLoad={onPageLoad} />
        )}
      </main>
      <EirFooter cmsFooterData={cmsFooterData?.data} />
    </Stack>
  );
};

export default Mobile;
